module.exports = {
  API_URL: 'API_URL_PLACEHOLDER',

  apiUrl: function() {
    return this.API_URL.indexOf('PLACEHOLDER') !== -1
      ? 'https://devapi03.cliento.com'
      : this.API_URL;
  }
};
